/**
 * Окно «Новая библиотека» / «Править библиотеку»: создание — редкое действие и
 * не должно висеть на экране постоянно, а правка из карточки открывает то же окно.
 *
 * Форма внутри одна и та же; режим правки включается передачей `library`.
 */
import { LibraryCreateForm } from "@/components/library/LibraryCreateForm";
import { Dialog } from "@/components/trends/Dialog";
import type { Library } from "@/lib/library";

export function LibraryDialog({
  open,
  onClose,
  library,
  onDone,
}: {
  open: boolean;
  onClose: () => void;
  library?: Library;
  onDone: (id: number) => void;
}) {
  return (
    <Dialog open={open} title={library ? "Править библиотеку" : "Новая библиотека"} onClose={onClose}>
      <div className="p-4">
        <LibraryCreateForm
          {...(library
            ? {
                libraryId: library.id,
                initial: { name: library.name, category: library.category_code, note: library.note ?? "" },
              }
            : {})}
          onCreated={(id) => {
            onDone(id);
            onClose();
          }}
          onCancel={onClose}
        />
      </div>
    </Dialog>
  );
}
